import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem
} from '@mui/material';

const JobCreate = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    companyDesc: '',
    title: '',
    description: '',
    requirements: '',
    location: 'Remote',
    salaryRangeMin: 0,
    salaryRangeMax: 0
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      salaryRangeMin: parseInt(formData.salaryRangeMin, 10),
      salaryRangeMax: parseInt(formData.salaryRangeMax, 10)
    });
    setFormData({
      companyName: '',
      companyDesc: '',
      title: '',
      description: '',
      requirements: '',
      location: 'Remote',
      salaryRangeMin: 0,
      salaryRangeMax: 0
    });
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Job</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              label="Company Name"
              value={formData.companyName}
              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Company Description"
              value={formData.companyDesc}
              onChange={(e) => setFormData({ ...formData, companyDesc: e.target.value })}
              fullWidth
              multiline
              rows={2}
              required
            />
            <TextField
              label="Job Title"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Job Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              fullWidth
              multiline
              rows={3}
              required
            />
            <TextField
              label="Requirements"
              value={formData.requirements}
              onChange={(e) => setFormData({ ...formData, requirements: e.target.value })}
              fullWidth
              multiline
              rows={2}
              required
            />
            <TextField
              select
              label="Location"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              fullWidth
              required
            >
              <MenuItem value="Remote">Remote</MenuItem>
              <MenuItem value="Hybrid">Hybrid</MenuItem>
              <MenuItem value="On-site">On-site</MenuItem>
            </TextField>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Minimum Salary"
                type="number"
                value={formData.salaryRangeMin}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  salaryRangeMin: e.target.value ? parseInt(e.target.value, 10) : 0 
                })}
                fullWidth
                inputProps={{ min: 0, step: 1 }}
              />
              <TextField
                label="Maximum Salary"
                type="number"
                value={formData.salaryRangeMax}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  salaryRangeMax: e.target.value ? parseInt(e.target.value, 10) : 0 
                })}
                fullWidth
                inputProps={{ min: 0, step: 1 }}
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Add Job
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default JobCreate;
